import React, {PropTypes as T} from 'react';

const LoadingIcon = ({ width = 24, height = 24, color = '#007DB3', bgColor = '#fff', className = '' }) => {
  // TODO: this ugliness is neccesary since React 0.14.8 does not support <animate> tag
  // in svg. Once we upgraded to React 15.X.X we can get rid of this and go back to the
  // normal svg!
  const content = `
    <circle cx="50" cy="50" r="40" stroke=${bgColor} fill="none" stroke-width="10" stroke-linecap="round" />
    <circle cx="50" cy="50" r="40" stroke=${color} fill="none" stroke-width="6" stroke-linecap="round">
      <animate
        attributeName="stroke-dashoffset"
        dur="2s"
        repeatCount="indefinite"
        from="0"
        to="502" />
      <animate
        attributeName="stroke-dasharray"
        dur="2s"
        repeatCount="indefinite"
        values="150.6 100.4;1 250;150.6 100.4" />
    </circle>`;
  return <svg
    aria-label="Loading Icon"
    width={width}
    height={height}
    viewBox="0 0 100 100"
    className={`icon__loading ${className}`}
    preserveAspectRatio="xMidYMid"
    xmlns="http://www.w3.org/2000/svg"
    dangerouslySetInnerHTML={{__html: content}} />;
};

LoadingIcon.propTypes = {
  width: T.number,
  height: T.number,
  color: T.string,
  bgColor: T.string,
  className: T.string
};

export default  LoadingIcon;



// WEBPACK FOOTER //
// ./frontend/react/components/common/icons/icon_loading.js